import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { shadows } from '@material-ui/system';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import {updateUserProfileAction, saveAComment} from "../../redux/modules/login";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import * as MainConstants from "../../utils/MainConstants";
import ReCAPTCHA from "react-google-recaptcha";
import {Checkbox, FormControl, FormControlLabel, FormGroup} from "@material-ui/core";
import DOMPurify from "dompurify";




const Styles = theme => ({
    root: Object.assign({}, AppBackground, MediumFont),
    gridPane: {width: '50%', display: 'inline-block'},
    paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
    videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
    penInfoPanel: {color: 'white', fontSize: 20},
    penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
    videoPanel: {marginTop: 0},
    penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
    metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    metricInfo: Object.assign({}, AppBackground, ThinBorder),
    multilineColor:{
        color:'red'
    }

});

const styles = theme => ({
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        marginBottom: theme.spacing.unit,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
    rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        margin: theme.spacing.unit,
    },
    extendedIcon: {
        marginRight: theme.spacing.unit,
    },
    margin: {
        margin: theme.spacing.unit * 2,
    },
    multilineColor:{
        color:'black',
        backgroundColor:'white'
    }
});

const GREEN       = '#1a736a';
const GREEN_LIGHT = '#f0f7f5';
const DARK        = '#1a2e1d';
const GRAY        = '#555';

const HELP_TOPICS = [
    { label: 'Product Questions' },
    { label: 'Orchid Care Questions' },
    { label: 'Sample Requests' },
    { label: 'Retail & Distribution Opportunities' },
    { label: 'Partnership Opportunities' },
    { label: 'Feedback & Suggestions' },
    { label: 'Media Inquiries' },
];


class ContactUs extends Component {

    state = {
        age: '',
        firstname: '',
        lastname:'',
        email:'',
        comment:'',
        userComment:{},
        captchaValue:"",
        privacy:false,
    };

    constructor(props) {
        super(props);

        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.handleEmailChange= this.handleEmailChange.bind(this);
        this.handleCommentChange = this.handleCommentChange.bind(this);
        this.saveVisitorComment = this.saveVisitorComment.bind(this);
        this.handleCaptchaChange= this.handleCaptchaChange.bind(this);
        this.sanitizeInput= this.sanitizeInput.bind(this);
        this.recaptchaRef = React.createRef();
        this.handleChangePrivacy= this.handleChangePrivacy.bind(this);
    }

    handleCaptchaChange = (value) => {
        this.setState({ captchaValue: value });
    };

    componentDidMount() {
        const { isAuthenticated ,updateUserProfileAction} = this.props;
        updateUserProfileAction(null, this.props.loginData.accessToken);
    }

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleFirstNameChange(event) {
        this.setState(Object.assign(this.state.userComment,{firstname:event.target.value}));
    }

    handleLastNameChange(event) {
        this.setState(Object.assign(this.state.userComment,{lastname:event.target.value}));
    }

    handleEmailChange(event) {
        this.setState(Object.assign(this.state.userComment,{email:event.target.value}));
    }

    handleCommentChange(event) {
        let sanitizedValue = this.sanitizeInput(event.target.value);
        this.setState(Object.assign(this.state.userComment,{comment: sanitizedValue}));
    }

    saveVisitorComment(event) {
        const {saveAComment} = this.props;
        var  returnString="";
        var tempLastName =  this.state.userComment.lastname;
        var tempFirstName = this.state.userComment.firstname;
        var tempEmail = this.state.userComment.email;
        var tempComment = this.state.userComment.comment;

        if((tempFirstName == null) || (tempFirstName.length == 0)){
            alert("Please provide your first name!");
        }else {
            if ((tempLastName == null) || (tempLastName.length == 0)) {
                alert("Please provide your last name!");
            }else {
                if ((tempEmail == null) || (tempEmail.length == 0)) {
                    alert("Please provide your Email!");
                } else {
                    if ((tempEmail.indexOf("@") == -1)) {
                        alert("Please provide proper Email address!");
                    }else{
                        if ((tempComment == null) || (tempComment.length == 0)) {
                            alert("Please provide your comment!");
                        }else if( this.state.privacy === false) {
                            alert("Please check the box, that you agree to our Privacy Policy. There is a link at the bottom of this page to our Privacy Policy");
                        } else {
                            if (this.state.captchaValue) {
                                if (window.gtag) {
                                    window.gtag('event', 'contact_form_submit_clicked', {
                                        event_category: 'engagement',
                                        event_label: 'Orchima Contact Form'
                                    });
                                }
                                saveAComment(DEFAULT_VESPAAN_SERVER.url, this.state.userComment, this.state.captchaValue);
                                this.recaptchaRef.current.reset();
                            } else {
                                console.log('Please complete the reCAPTCHA');
                                alert('Please make sure the reCAPTCHA is complete');
                                //9-30-2025 Remove This. I added this for testing only.
                                saveAComment(DEFAULT_VESPAAN_SERVER.url, this.state.userComment, this.state.captchaValue);
                            }
                        }
                    }
                }
            }
        }

        return returnString;
    }

    sanitizeInput(value){
        let cleanText = DOMPurify.sanitize(value);
        return cleanText;
    };

    handleChangePrivacy(event) {
        this.setState({privacy:event.target.checked});
    };


    render() {
        const { classes } = this.props;

        return (
            <div style={{ backgroundColor: '#f9f9f7', minHeight: '100vh' }}>

                {/* Top nav */}
                <div style={{ backgroundColor: DARK, padding: '14px 24px' }}>
                    <a href="/home" style={{ color: '#ffffff', textDecoration: 'none', fontSize: 14, fontWeight: 600, letterSpacing: 0.5 }}>
                        ← Back to Orchima Home
                    </a>
                </div>

                {/* Hero */}
                <div style={{ backgroundColor: GREEN, padding: '56px 24px', textAlign: 'center' }}>
                    <p style={{ fontSize: 12, fontWeight: 700, color: '#a8d5cf', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 12, marginTop: 0 }}>
                        GET IN TOUCH
                    </p>
                    <h1 style={{ fontSize: 'clamp(24px, 5vw, 36px)', fontWeight: 700, color: '#ffffff', lineHeight: 1.3, margin: '0 auto 16px auto', maxWidth: 600 }}>
                        We'd Love to Hear From You
                    </h1>
                    <p style={{ fontSize: 17, color: '#d0ede9', maxWidth: 580, margin: '0 auto', lineHeight: 1.7 }}>
                        Whether you have a question about Orchima™, orchid care, partnerships, or feedback — we're here to help.
                    </p>
                </div>

                {/* Main content */}
                <div style={{ maxWidth: 1040, margin: '0 auto', padding: '48px 24px' }}>

                    {/* Two-column: topics + form */}
                    <div style={{ overflow: 'hidden' }}>
                        <Grid container spacing={32}>

                            {/* Left column */}
                            <Grid item xs={12} sm={12} md={5} lg={5}>

                                {/* What can we help with */}
                                <div style={{ backgroundColor: '#ffffff', borderRadius: 10, padding: '28px 28px', boxShadow: '0 2px 12px rgba(0,0,0,0.07)', marginBottom: 20 }}>
                                    <h2 style={{ fontSize: 20, fontWeight: 700, color: DARK, marginBottom: 20, marginTop: 0 }}>
                                        What Can We Help With?
                                    </h2>
                                    {HELP_TOPICS.map((topic, i) => (
                                        <div key={i} style={{ display: 'flex', alignItems: 'center', marginBottom: 13 }}>
                                            <span style={{ color: GREEN, fontWeight: 700, fontSize: 17, marginRight: 12, flexShrink: 0, lineHeight: 1 }}>✓</span>
                                            <span style={{ fontSize: 15, color: '#444', lineHeight: 1.4 }}>{topic.label}</span>
                                        </div>
                                    ))}
                                </div>

                                {/* Contact info */}
                                <div style={{ backgroundColor: DARK, borderRadius: 10, padding: '24px 28px' }}>
                                    <p style={{ fontSize: 11, fontWeight: 700, color: '#7ab5ad', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 14, marginTop: 0 }}>
                                        CONTACT INFO
                                    </p>
                                    <p style={{ fontSize: 15, color: '#d0ede9', lineHeight: 2.1, margin: 0 }}>
                                        <strong style={{ color: '#ffffff' }}>Email</strong>
                                        <br />
                                        <a href="mailto:Info@Vespaan.com" style={{ color: '#7ab5ad', textDecoration: 'none' }}>Info@Vespaan.com</a>
                                    </p>
                                    <p style={{ fontSize: 15, color: '#d0ede9', lineHeight: 2.1, marginTop: 12, marginBottom: 0 }}>
                                        <strong style={{ color: '#ffffff' }}>Company</strong>
                                        <br />
                                        <span style={{ color: '#b8cfc8' }}>Vespaan Corporation</span>
                                    </p>
                                    <p style={{ fontSize: 15, color: '#d0ede9', lineHeight: 2.1, marginTop: 12, marginBottom: 0 }}>
                                        <strong style={{ color: '#ffffff' }}>Website</strong>
                                        <br />
                                        <span style={{ color: '#b8cfc8' }}>Orchima.com</span>
                                    </p>
                                </div>

                            </Grid>

                            {/* Right column: form */}
                            <Grid item xs={12} sm={12} md={7} lg={7}>
                                <div style={{ backgroundColor: '#ffffff', borderRadius: 10, padding: '28px 28px', boxShadow: '0 2px 12px rgba(0,0,0,0.07)' }}>
                                    <h2 style={{ fontSize: 20, fontWeight: 700, color: DARK, marginBottom: 6, marginTop: 0 }}>
                                        Send Us a Message
                                    </h2>
                                    <p style={{ fontSize: 14, color: '#888', marginBottom: 24, marginTop: 0, lineHeight: 1.6 }}>
                                        We usually respond within 1–2 business days.
                                    </p>

                                    <Grid container spacing={16}>
                                        <Grid item xs={6} sm={6}>
                                            <TextField
                                                variant="filled"
                                                required
                                                id="Description-fn"
                                                name="firstname"
                                                label="First Name"
                                                fullWidth
                                                InputProps={{ classes: { input: classes.multilineColor } }}
                                                value={this.state.userComment.firstname || ''}
                                                onChange={this.handleFirstNameChange}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={6}>
                                            <TextField
                                                variant="filled"
                                                required
                                                id="DisplayName"
                                                name="lastname"
                                                label="Last Name"
                                                fullWidth
                                                InputProps={{ classes: { input: classes.multilineColor } }}
                                                value={this.state.userComment.lastname || ''}
                                                onChange={this.handleLastNameChange}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <TextField
                                                variant="filled"
                                                required
                                                id="Description-email"
                                                name="email"
                                                label="Email Address"
                                                fullWidth
                                                InputProps={{ classes: { input: classes.multilineColor } }}
                                                value={this.state.userComment.email || ''}
                                                onChange={this.handleEmailChange}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <TextField
                                                rowsMax="6"
                                                rows="6"
                                                variant="filled"
                                                multiline={true}
                                                required
                                                id="comment"
                                                name="comment"
                                                label="Your Message"
                                                fullWidth
                                                InputProps={{ classes: { input: classes.multilineColor } }}
                                                value={this.state.userComment.comment || ''}
                                                onChange={this.handleCommentChange}
                                            />
                                            {this.state.userComment.comment !== undefined && (
                                                <p style={{ fontSize: 12, color: '#aaa', textAlign: 'right', margin: '4px 0 0 0' }}>
                                                    {500 - this.state.userComment.comment.length} / 500 characters remaining
                                                </p>
                                            )}
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <FormControl component="fieldset" style={{ marginBottom: 16 }}>
                                                <FormGroup>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={this.state.privacy}
                                                                onChange={this.handleChangePrivacy}
                                                                name="privacy"
                                                                style={{ color: GREEN }}
                                                            />
                                                        }
                                                        label={
                                                            <Typography variant="body1" style={{ fontSize: 14, color: GRAY }}>
                                                                I agree to the{' '}
                                                                <a href="/privacy" style={{ color: GREEN, fontWeight: 600 }}>Privacy Policy</a>
                                                            </Typography>
                                                        }
                                                    />
                                                </FormGroup>
                                            </FormControl>

                                            <div style={{ marginBottom: 20 }}>
                                                <ReCAPTCHA
                                                    sitekey={MainConstants.RECAPTCHASITEKEY}
                                                    size="normal"
                                                    ref={this.recaptchaRef}
                                                    onChange={this.handleCaptchaChange}
                                                    style={{ display: 'flex', justifyContent: 'flex-start' }}
                                                />
                                            </div>

                                            <Button
                                                size="large"
                                                type="button"
                                                variant="contained"
                                                onClick={this.saveVisitorComment}
                                                style={{
                                                    backgroundColor: GREEN,
                                                    color: '#ffffff',
                                                    fontSize: 16,
                                                    fontWeight: 600,
                                                    borderRadius: 6,
                                                    textTransform: 'none',
                                                    padding: '12px 36px',
                                                    width: '100%',
                                                    boxShadow: 'none',
                                                }}
                                            >
                                                Send Message
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>

                        </Grid>
                    </div>

                    {/* Feedback invitation */}
                    <div style={{ backgroundColor: GREEN_LIGHT, borderRadius: 10, padding: '28px 28px', marginTop: 32, marginBottom: 24 }}>
                        <h2 style={{ fontSize: 20, fontWeight: 700, color: DARK, marginBottom: 12, marginTop: 0 }}>
                            Share Your Orchid Experience
                        </h2>
                        <p style={{ fontSize: 16, color: GRAY, lineHeight: 1.8, margin: 0 }}>
                            Orchima™ continues to evolve through feedback from orchid owners and growers. If you have ideas,
                            suggestions, or experiences you'd like to share — about the product, the watering routine, or orchid
                            care in general — we'd love to hear from you. Every message helps us improve.
                        </p>
                    </div>

                    {/* Retail & Partnership */}
                    <div style={{ backgroundColor: DARK, borderRadius: 10, padding: '28px 28px', marginBottom: 40 }}>
                        <h2 style={{ fontSize: 20, fontWeight: 700, color: '#ffffff', marginBottom: 12, marginTop: 0 }}>
                            Retail &amp; Partnership Inquiries
                        </h2>
                        <p style={{ fontSize: 15, color: '#b8cfc8', lineHeight: 1.8, marginBottom: 14, marginTop: 0 }}>
                            Interested in carrying Orchima™ in your store, garden center, or online shop? We welcome conversations
                            with retailers, distributors, and commercial partners of all sizes.
                        </p>
                        <p style={{ fontSize: 15, color: '#b8cfc8', lineHeight: 1.8, margin: 0 }}>
                            For retail, wholesale, or partnership inquiries, please reach out directly at{' '}
                            <a href="mailto:Info@Vespaan.com?subject=Orchima Retail Inquiry" style={{ color: '#7ab5ad', fontWeight: 600, textDecoration: 'none' }}>
                                Info@Vespaan.com
                            </a>
                            {' '}or use the form above.
                        </p>
                    </div>

                    {/* Footer */}
                    <div style={{ textAlign: 'center', paddingBottom: 24, borderTop: '1px solid #e0e0e0', paddingTop: 24 }}>
                        <p style={{ fontSize: 13, color: '#aaa', marginBottom: 16, marginTop: 0 }}>
                            © 2025 Vespaan Inc. — Orchima™ (Patent Pending). All rights reserved.
                        </p>
                        <a href="/home" style={{ color: GREEN, fontWeight: 600, fontSize: 15, textDecoration: 'none', marginRight: 28 }}>
                            ← Back to Orchima Home
                        </a>
                        <a href="/privacy" style={{ color: GREEN, fontWeight: 600, fontSize: 15, textDecoration: 'none' }}>
                            Privacy Policy
                        </a>
                    </div>

                </div>
            </div>
        );
    }
}

ContactUs.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        isAuthenticatedBool: state.login.isAuthenticatedBool,
        userProfile: state.login.userProfile,
        loginData:state.login.loginData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        updateUserProfileAction:updateUserProfileAction,
        saveAComment:saveAComment,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ContactUs));
